import {
  Field,
  FieldOrientation,
  FieldSubtype,
  FieldType,
} from "@/core/types/types";
import { subDays } from "date-fns";

export enum FieldName {
  Airline = "airline",
  DepartureDate = "departureDate",
  DepartureAirport = "originIATA",
  ArrivalAirport = "destinationIATA",
  NumberOfPassengers = "numberOfPassengers",
  CustomerGender = "customerGender",
  CustomerFirstName = "customerFirstName",
  CustomerLastName = "customerLastName",
  CustomerEmail = "customerEmail",
  CustomerIsMinor = "isMinor",
}

// TODO: translations
export const fields: { [key in FieldName]: Field } = {
  [FieldName.Airline]: {
    id: FieldName.Airline,
    key: FieldName.Airline,
    label: "label.airlineName",
    type: FieldType.TextField,
    properties: {
      subtype: FieldSubtype.Autosuggest,
      source: "airlines",
    },
    validate: {
      required: true,
    },
  },
  [FieldName.DepartureDate]: {
    id: FieldName.DepartureDate,
    key: FieldName.DepartureDate,
    label: "date.datepicker.label",
    type: FieldType.TextField,
    properties: {
      subtype: FieldSubtype.Date,
    },
    validate: {
      required: true,
      maxDate: subDays(new Date(), -14),
    },
  },
  [FieldName.DepartureAirport]: {
    id: FieldName.DepartureAirport,
    key: FieldName.DepartureAirport,
    label: "airports.departure.label",
    type: FieldType.TextField,
    properties: {
      source: "airports",
      subtype: FieldSubtype.Autosuggest,
    },
    validate: {
      required: true,
    },
  },
  [FieldName.ArrivalAirport]: {
    id: FieldName.ArrivalAirport,
    key: FieldName.ArrivalAirport,
    label: "airports.arrival.label",
    type: FieldType.TextField,
    properties: {
      source: "airports",
      subtype: FieldSubtype.Autosuggest,
    },
    validate: {
      required: true,
    },
  },
  [FieldName.NumberOfPassengers]: {
    id: FieldName.NumberOfPassengers,
    key: FieldName.NumberOfPassengers,
    label: "label.numberOfPassengers",
    type: FieldType.Number,
    properties: {},
    validate: {
      required: true,
      regex: "^([1-9]\\d*)$",
      min: 1,
      max: 20,
    },
  },
  [FieldName.CustomerGender]: {
    id: FieldName.CustomerGender,
    key: FieldName.CustomerGender,
    label: "",
    type: FieldType.Radio,
    properties: {
      orientation: FieldOrientation.Horizontal,
    },
    values: [
      {
        label: "common.gender.male",
        value: "M",
      },
      {
        label: "common.gender.female",
        value: "F",
      },
      {
        label: "common.gender.other",
        value: "D",
      },
    ],
    validate: {
      required: true,
    },
  },
  [FieldName.CustomerFirstName]: {
    id: FieldName.CustomerFirstName,
    key: FieldName.CustomerFirstName,
    label: "customerContactInfo.firstName",
    type: FieldType.TextField,
    properties: {},
    validate: {
      required: true,
    },
  },
  [FieldName.CustomerLastName]: {
    id: FieldName.CustomerLastName,
    key: FieldName.CustomerLastName,
    label: "customerContactInfo.lastName",
    type: FieldType.TextField,
    properties: {},
    validate: {
      required: true,
    },
  },
  [FieldName.CustomerEmail]: {
    id: FieldName.CustomerEmail,
    key: FieldName.CustomerEmail,
    label: "customerContactInfo.email",
    type: FieldType.TextField,
    properties: {},
    disabled: true,
  },
  [FieldName.CustomerIsMinor]: {
    id: FieldName.CustomerIsMinor,
    key: FieldName.CustomerIsMinor,
    label: "customerInformation.isMinor",
    type: FieldType.Checkbox,
    properties: {},
  },
};
